import { inject } from '@angular/core';
import { ModuleTranslationLoaderRegistry } from '@softapps/core';

export const SOFTLINE_TRANSLATION_MODULE_WWS_DOCUMENTS = 'wws-core-documents';

/** Registers and loads this lib's translations on first use (idempotent), so no app has to
 *  import the lib at boot. Must run in an injection context. */
export function ensureDocumentsTranslations(): void {
  const registry = inject(ModuleTranslationLoaderRegistry);
  registry.register(SOFTLINE_TRANSLATION_MODULE_WWS_DOCUMENTS, {
    de: () => import('../i18n/de.json'),
    en: () => import('../i18n/en.json'),
  });
  void registry.load(SOFTLINE_TRANSLATION_MODULE_WWS_DOCUMENTS);
}
